<div class="flex-column justify-self-center">
  <mat-card *ngFor="let post of posts" class="m-2">
    <mat-card-header>
      <mat-card-title
        >{{ post.createdBy.firstName }}
        {{ post.createdBy.lastName }}</mat-card-title
      >
    </mat-card-header>
    <div>
      <img [src]="post.attachmentURL" class="max-h-36 m-3" />
    </div>

    <mat-card-content> {{ post.body }} </mat-card-content>
    <mat-card-actions>
      <button mat-stroked-button (click)="viewComments(post.id)" color="accent">
        Comments ({{ post.comments.length }})
      </button>
    </mat-card-actions>

    <div
      *ngIf="showComments && post.id === this.commentSectionPostId"
      class="m-2"
    >
      <mat-card *ngFor="let comment of post.comments" class="mt-2">
        <mat-card-header>
          <mat-card-subtitle
            >{{ comment.createdBy.firstName }} {{ comment.createdBy.lastName }}
          </mat-card-subtitle>
        </mat-card-header>

        <div><img [src]="comment.attachmentURL" class="max-h-36 m-3" /></div>

        <mat-card-content> {{ comment.body }} </mat-card-content>
      </mat-card>
    </div>
  </mat-card>
</div>
